import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { BedroomsActionTypes, ResponseDataRequests } from './types'

type Options = {
  page?: number
  partner_id?: Id
  partner_hotel_id?: Id
}

export const getBedrooms = createAction(
  BedroomsActionTypes.GET_BEDROOMS,
  action =>
    (
      options = {
        page: 1,
        partner_id: '',
        partner_hotel_id: ''
      } as Options
    ) =>
      action({ options })
)

export const getBedroomsFailure = createAction(
  BedroomsActionTypes.GET_BEDROOMS_FAILURE,
  action => (message: string) => action({ message })
)

export const getBedroomsSuccess = createAction(
  BedroomsActionTypes.GET_BEDROOMS_SUCCESS,
  action =>
    ({ partner_hotel_rooms }: ResponseDataRequests) =>
      action({ partner_hotel_rooms })
)

export const sendBedrooms = createAction(
  BedroomsActionTypes.SEND_BEDROOMS,
  action =>
    (
      partner_hotel_rooms: [
        {
          partner_id: Id
          partner_hotel_id: Id
          partner_hotel_room_id: Id
          category: String
          max_adults: Number
          comments: String
          active: Boolean
        }
      ]
    ) =>
      action({ partner_hotel_rooms })
)

export const sendBedroomsFailure = createAction(
  BedroomsActionTypes.SEND_BEDROOMS_FAILURE,
  action => (message: string) => action({ message })
)

export const sendBedroomsSuccess = createAction(
  BedroomsActionTypes.SEND_BEDROOMS_SUCCESS,
  action => () => action()
)
